export default __webpack_public_path__ + "static/media/boy-beverly.063549aa.jpg";